module.exports = __webpack_public_path__ + "static/azubu-e3-preview-a664583e1f49eb4fa7980d1f303e534f.mp4";